var React = require('react');

function In (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"#fff","fillRule":"evenodd","d":"M9.037 14.168h2.433V23H9.037v-8.83zm1.154-1.104h-.017c-.88 0-1.452-.675-1.452-1.53 0-.872.588-1.534 1.486-1.534s1.45.66 1.467 1.532c0 .854-.57 1.532-1.484 1.532zM21.202 23h-2.758v-4.57c0-1.197-.431-2.012-1.38-2.012-.726 0-1.13.55-1.317 1.082-.07.19-.06.455-.06.721V23h-2.732s.035-8.096 0-8.832h2.732v1.386c.162-.606 1.035-1.47 2.428-1.47 1.73 0 3.087 1.27 3.087 4.005V23z","clipRule":"evenodd","key":0}),React.createElement("path",{"stroke":"#fff","d":"M.5 8.789L14.722.577 28.945 8.79V25.21l-14.223 8.212L.5 25.21V8.79z","key":1})]);
}

In.defaultProps = {"width":"30","height":"34","fill":"none","viewBox":"0 0 30 34"};

module.exports = In;

In.default = In;
